import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export interface ScrollBorderClasses {
	/** styles applied to the root element */
	root: string;
	hasOverflow: string;
	hasHorizontalOverflow: string;
	scrolled: string;
	scrolledHorizontally: string;
	scrolledToEnd: string;
	scrolledToEndHorizontally: string;
	scrollSentinel: string;

	scrollBorder: string;
	scrollBorderBottom: string;
	scrollBorderRight: string;
	scrollBorderLeft: string;
	scrollBorderTop: string;
	scrollWrapper: string;
}

export const getScrollBorderUtilityClass = (slot: string) =>
	generateUtilityClass('ScrollBorder', slot);

export const scrollBorderClasses = generateUtilityClasses<
	keyof ScrollBorderClasses
>('ScrollBorder', [
	'root',
	'hasOverflow',
	'hasHorizontalOverflow',
	'scrolled',
	'scrolledHorizontally',
	'scrolledToEnd',
	'scrolledToEndHorizontally',
	'scrollBorder',
	'scrollBorderBottom',
	'scrollBorderLeft',
	'scrollBorderRight',
	'scrollBorderTop',
	'scrollSentinel',
	'scrollWrapper',
]);
export default scrollBorderClasses;
